import { render, staticRenderFns } from "./FuturesAndNotAcceptedTab.vue?vue&type=template&id=774f9680&lang=pug"
import script from "./FuturesAndNotAcceptedTab.vue?vue&type=script&lang=ts"
export * from "./FuturesAndNotAcceptedTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports